export type SelectionChange<TId extends string> = {
  ids: readonly TId[];
  selected: boolean;
  value: TId;
};

export function getUniqueIds<TId extends string>(ids: readonly TId[]) {
  return ids.filter((id, index) => id.length > 0 && ids.indexOf(id) === index);
}

export function toggleSelection<TId extends string>({
  ids,
  selected,
  value,
}: SelectionChange<TId>) {
  if (!selected) {
    return ids.filter((id) => id !== value);
  }

  if (ids.includes(value)) {
    return [...ids];
  }

  return [...ids, value];
}

export function areAllVisibleSelected<TId extends string>({
  selectedIds,
  visibleIds,
}: {
  selectedIds: readonly TId[];
  visibleIds: readonly TId[];
}) {
  return (
    visibleIds.length > 0 &&
    visibleIds.every((visibleId) => selectedIds.includes(visibleId))
  );
}
